// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, number, object, oneOfType, string } from 'prop-types'
import ErrorSimple from './ErrorSimple'

const LabeledTextarea = props => {
  const {
    autoFocus,
    className,
    disabled,
    id,
    input,
    label,
    meta,
    placeholder,
    rows,
  } = props

  return (
    <div
      className={`labeled-textarea ${className || ``}`}
      title={input.value}>
      { label && <label id={`${id}-label`}>{label}</label> }
      <div>
        <textarea
          {...input}
          autoFocus={autoFocus}
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          rows={rows} />
        <ErrorSimple
          error={meta.error}
          idRoot={id} />
      </div>
    </div>
  )
}

LabeledTextarea.propTypes = {
  autoFocus: bool,
  className: string,
  disabled: bool,
  id: string.isRequired,
  input: object.isRequired,
  label: oneOfType([
    string,
    object,
  ]),
  meta: object.isRequired,
  placeholder: string,
  rows: number,
}

export default LabeledTextarea
